import moment from 'moment';
import countriesDB from 'countries-db'
import momentTimeZone from 'moment-timezone';

export function getDateUsingTimeZone(country, date) {
    if (!country) return moment(date).format('dddd, DD-MM-YYYY / hh:mm A');
    else {
        let convertedDate;
        const timezones = countriesDB && countriesDB.getCountry(country, 'timezones');
        if (timezones && timezones.length > 0) {
            convertedDate = (timezones && timezones.length > 0) ? momentTimeZone.tz(date, timezones[0]) : null;
        }
        if (convertedDate && convertedDate != null) {
            return moment(convertedDate).format('dddd, DD-MM-YYYY / hh:mm A');
        } else {
            return moment(date).format('dddd, DD-MM-YYYY / hh:mm A');
        }
    }
}

export function getTimeZone(country) {
    if (!country) return null;
    else {
        const timezones = countriesDB && countriesDB.getCountry(country, 'timezones');
        if (timezones && timezones.length > 0) {
            return timezones[0];
        } else {
            return null
        }
    }
}

export function workTimeConversion(duration) {
    duration = duration.toFixed(2);
    if (duration >= 60) {
      var totalHour = Math.floor(duration / 60);
      var totalMin = Math.floor(duration % 60);
      return totalHour + "h " + totalMin + "m";
    } else if (duration >= 1 && duration < 60) {
      var totalMin = Math.floor(duration);
      var totalSec = duration - totalMin;
      totalSec = Math.floor(totalSec * 60);
      return totalMin + "m " + totalSec + "s";
    } else {
      var totalSec = Math.floor(duration * 60);
      return totalSec + "s";
    }
}


export function durationConversion(duration){
    duration = duration.toFixed(2);
    if (duration >= 60) {
      var totalHour = Math.floor(duration / 60);
      var totalMin = Math.floor(duration % 60);
      return totalHour + " hr " + totalMin + " mins";
    } else if (duration >= 1 && duration < 60) {
      var totalMin = Math.floor(duration);
      var totalSec = duration - totalMin;
      totalSec = Math.floor(totalSec * 60);
      return totalMin + " mins ";
    }
}